import validatorjs from 'validatorjs';

function MarketplaceOrderEditOrderLinesStepForm() {
	var Validator = validatorjs;
	Validator.register(
		'numericMinValue',
		value => {
			return 1 / value > 0;
		},
		'NUMERICMINVALUE'
	);
	Validator.register(
		'notZero',
		value => {
			return value != 0;
		},
		'NOTZEROVALUE'
	);
	Validator.register(
		'notDecimal',
		value => {
			return !value.toString().includes('.');
		},
		'NOTDECIMALVALUE'
	);
	Validator.register(
		'decimalLength',
		value => {
			var decimal = value.toString().split('.')[1];
			if (decimal) {
				return decimal.length <= 2;
			}
			return true;
		},
		'MINIMUMLENGHT'
	);
	return {
		fields: [
			'orderLinesStep.orderLines',
			'orderLinesStep.orderLines[].product',
			'orderLinesStep.orderLines[].quantity',
			'orderLinesStep.orderLines[].unitPrice',
			'orderLinesStep.orderLines[].orderLineStatus',
			'orderLinesStep.orderLines[].taxPaid',
			'orderLinesStep.orderLines[].id',
			'orderLinesStep.orderLines[].productId',
			'orderLinesStep.orderLines[].sellerId',
		],
		labels: {
			'orderLinesStep.orderLines[].product': 'MARKETPLACEORDEREDITFORM.SKU',
			'orderLinesStep.orderLines[].quantity': 'MARKETPLACEORDEREDITFORM.QUANTITY',
			'orderLinesStep.orderLines[].unitPrice': 'MARKETPLACEORDEREDITFORM.UNITPRICE',
			'orderLinesStep.orderLines[].orderLineStatus': 'MARKETPLACEORDEREDITFORM.ORDERLINESTATUS',
			'orderLinesStep.orderLines[].taxPaid': 'MARKETPLACEORDEREDITFORM.TAXPAID',
		},
		rules: {
			'orderLinesStep.orderLines[].product': 'required',
			'orderLinesStep.orderLines[].quantity': 'required|numeric|numericMinValue|notZero|notDecimal',
			'orderLinesStep.orderLines[].orderLineStatus': 'required',
			'orderLinesStep.orderLines[].unitPrice': 'numeric|decimalLength',
			'orderLinesStep.orderLines[].taxPaid': 'numeric|decimalLength',
		},
	};
}

export default MarketplaceOrderEditOrderLinesStepForm;



// WEBPACK FOOTER //
// ./src/modules/order/forms/wizard/MarketplaceOrderEditOrderLinesStepForm.js